import { render, staticRenderFns } from "./Entidade.vue?vue&type=template&id=7f890b78&scoped=true&"
import script from "./Entidade.vue?vue&type=script&lang=js&"
export * from "./Entidade.vue?vue&type=script&lang=js&"
import style0 from "./Entidade.vue?vue&type=style&index=0&id=7f890b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f890b78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
